import AccountSelect from '../../components/login/AccountSelect';

const AccountSelectPortal = (props) => (
  <AccountSelect {...props} />
);

export default AccountSelectPortal;
